module.exports = __webpack_public_path__ + "assets/Blase_Niere_Prostata.46b7d143.png";